import React from 'react';
import { AppProviders } from './core/providers/AppProviders';
import { AppRouter } from './core/router/AppRouter';

/**
 * App component
 * Root component of the application
 */
const App: React.FC = () => {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
};

export default App;
